import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import { Card, Heading, Loader, Popup, ToastErrorTile } from "uikit/components";
import { useGenerateRegionSummary } from "hooks/regionSummary";
import RegionSummaryView from "components/regionSummary/RegionSummaryView/RegionSummaryView";
import RegionWithMapSummaryView from "components/regionSummary/RegionWithMapSummaryView/RegionWithMapSummaryView";
import RegionMap from "maps/RegionMap";
import styles from "./RegionSummaryPage.module.styl";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";
import { MediaContext } from "app/media/MediaContext";

export default function RegionSummaryPage() {
    const { regionId } = useParams();

    const [result, setResult] = useState(null);
    const [showPlaceHolder, setShowPlaceHolder] = useState(false);
    const { isMobile } = useContext(MediaContext);

    const { build: generateRegionSummary, isLoading: isGeneratingRegionSummary } =
        useGenerateRegionSummary({
            onSuccess: (data) => setResult(data),
            onError: (error) => {
                const data = error.response.data;
                if (data.status === 422) setShowPlaceHolder(true);
                else toast.error(<ToastErrorTile error={error} />);
            },
        });

    useEffect(() => {
        generateRegionSummary(regionId);
    }, [generateRegionSummary, regionId]);

    if (isGeneratingRegionSummary) {
        return (
            <>
                <Helmet>
                    <title>Панель управления отраслью спорта</title>
                </Helmet>
                <Popup appearance="adaptive">
                    <Loader position={"margin-auto"} text={"Подождите. Данные загружаются."} testName="loader-text" />
                </Popup>
            </>
        );
    }

    if (showPlaceHolder) {
        return (
            <>
                <Helmet>
                    <title>Панель управления отраслью спорта</title>
                </Helmet>
                <Heading size={"h1"} className={styles.placeHolder} name="data-is-not-ready-header">
                    В настоящий момент данные для дашборда ещё не сформированы. Повторите запрос
                    завтра.
                </Heading>
            </>
        );
    }

    if (result != null) {
        return (
            <>
                <Helmet>
                    <title data-test-name="region-summary-title">Панель управления отраслью спорта: {result.report.name}</title>
                    <meta
                        name="apple-mobile-web-app-title"
                        content={`Панель управления отраслью спорта: ${result.report.name}`}
                    />
                    <meta
                        name="application-name"
                        content={`Панель управления отраслью спорта: ${result.report.name}`}
                    />
                </Helmet>
                <Heading size={"h1"} className={styles.heading} name="region-summary-main-header">
                    Панель управления отраслью спорта: {result.report.name}
                </Heading>
                {result.regionMunicipalityMapHighlights.length > 0 ? (
                    <RegionWithMapSummaryView
                        currentDate={result.report.currentDate}
                        previousWeekStartDate={result.report.previousWeekStartDate}
                        previousWeekEndDate={result.report.previousWeekEndDate}
                        currentWeekStartDate={result.report.currentWeekStartDate}
                        currentWeekEndDate={result.report.currentWeekEndDate}
                        regionSummaryData={result.report.summary}
                        regionId={result.report.regionId}
                        regionRatingModel={result.report.regionRatingModel}
                        regionStatsModel={result.report.regionStatsModel}
                        type={"Region"}
                        digestDocument={result.report.digestDocument}
                    >
                        <RegionMap
                            regionId={result.report.regionId}
                            highlightedRegions={result.regionMunicipalityMapHighlights.map(
                                (x) => x.municipalityId,
                            )}
                        />
                    </RegionWithMapSummaryView>
                ) : isMobile ? (
                    <RegionSummaryView
                        currentDate={result.report.currentDate}
                        previousWeekStartDate={result.report.previousWeekStartDate}
                        previousWeekEndDate={result.report.previousWeekEndDate}
                        currentWeekStartDate={result.report.currentWeekStartDate}
                        currentWeekEndDate={result.report.currentWeekEndDate}
                        regionSummaryData={result.report.summary}
                        regionId={result.report.regionId}
                        regionRatingModel={result.report.regionRatingModel}
                        regionStatsModel={result.report.regionStatsModel}
                        digestDocument={result.report.digestDocument}
                    />
                ) : (
                    <Card borderRadius={"giant"} padding={"none"} className={styles.form}>
                        <RegionSummaryView
                            currentDate={result.report.currentDate}
                            previousWeekStartDate={result.report.previousWeekStartDate}
                            previousWeekEndDate={result.report.previousWeekEndDate}
                            currentWeekStartDate={result.report.currentWeekStartDate}
                            currentWeekEndDate={result.report.currentWeekEndDate}
                            regionSummaryData={result.report.summary}
                            regionId={result.report.regionId}
                            regionRatingModel={result.report.regionRatingModel}
                            regionStatsModel={result.report.regionStatsModel}
                            digestDocument={result.report.digestDocument}
                        />
                    </Card>
                )}
            </>
        );
    }
}
